import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { SearchbarService } from './../../services/searchbar.service';
import { ToolBarManager } from '../../managers/toolbar-manager';
import { ClienteManager } from 'src/app/managers/cliente-manager';
import { Router } from '@angular/router';
import { Cliente } from 'src/app/persistences/cliente';
import { Subscription } from 'rxjs';
import { ContaService } from 'src/app/services/conta.service';
import { ConfigService } from 'src/app/services/config.service';
import { MuralService } from './../../services/mural.service';
import { MensagemMural } from 'src/app/persistences/mensagem-mural';
import { ConsultaCustomizada } from 'src/app/persistences/consulta-customizada';
import { ConsultaDetalhada } from 'src/app/persistences/consulta-detalhada';
import { PesquisaAvancadaComponent } from '../pesquisa-avancada/pesquisa-avancada.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchBarComponent } from '../search-bar/search-bar.component';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';

@Component({
  standalone: false,
	selector: 'app-toolbar',
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit, OnDestroy  {
	@ViewChild('searchbar', { static: false }) searchbar: SearchBarComponent;
	@Input()
	public pesquisaVisivel = true;
	public logoMini: boolean;
	@Input()
	public nomeUsuario: string;
	public logoEmpresa: string;
	private subscription: Subscription;
	@Input()
	public cliente: Cliente;
	public isCliente = parseInt(localStorage.getItem("cd_usuario_business")) === 0 ? true : false;
	public temAcesso = parseInt(localStorage.getItem('tem_acesso_business')) == 0 ? false : true;
	public temWhatsapp: boolean;
	public whatsapp: string;
	public utilizaMural: boolean;
	public mensagensMural: MensagemMural[];
	public mensagensNaoLidas = 0;
	private muralSubscription: Subscription;
	public consultaCustomizada = new ConsultaCustomizada;
	public consultaDetalhada = new ConsultaDetalhada();
	public qtdFiltros = 0;

	constructor(
		private clienteSingleton: ClienteSingletonService,
		private clienteManager: ClienteManager,
		private searchbarService: SearchbarService,
		private toolbarManager: ToolBarManager,
		private router: Router,
		private contaService: ContaService,
		public configService: ConfigService,
		private muralService: MuralService,
		public dialog: MatDialog,
		public snackbarManager: SnackbarManager
	) { }
	
	ngOnInit() {				
		this.checkWindowSize();	
		this.subscription = this.clienteSingleton.getClienteObservable().subscribe((cliente) => {
			this.cliente = cliente;	
			if (this.isCliente){
				this.nomeUsuario = this.cliente.getNmFantasia;
			}else{
				this.toolbarManager.getFuncionario().subscribe(res => this.nomeUsuario = res);
			}
			if (this.cliente.getClienteFilial) {		
				this.logoEmpresa = this.cliente.getClienteFilial.getImgStr;
			}			
		});			
		if(this.isCliente)
			this.contaService.getContatos().subscribe((contato)=>{
				this.temWhatsapp = contato.flWhatsapp;
				this.whatsapp = contato.celularComercial;
				const contatos = {
					temWhatsapp: contato.flWhatsapp,
					celularComercial: contato.celularComercial
				}
				localStorage.setItem("contato", JSON.stringify(contatos));
			})
			if(this.configService.getConfig().getUntilizaMuralAvisos === "S"){
				this.utilizaMural = true;
			}else{
				this.utilizaMural = false;
			}
		this.muralService.getMensagensMural().subscribe((mensagens)=>{
			this.mensagensMural = mensagens;
			this.muralService.getMensagensNaoLidas(mensagens);
		});
		this.muralSubscription = this.muralService.getMensagensNaoLidasObservable().subscribe(
			(count) => {
				this.mensagensNaoLidas = count;
			}
		);
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
		this.muralSubscription?.unsubscribe();
	}

	emitIdsPesquisa(ids: any) {
		this.searchbarService.emitIdsPesquisa(ids);
	}

	emitIsLoading(boolean: any) {
		this.searchbarService.emitIsLoading(boolean);
	}

	emitOcultarAbas(boolean: any) {
		this.searchbarService.emitOcultarAbas(boolean);
	}

	@HostListener('window:resize')
	onResize() {
		this.checkWindowSize();
	}

	checkWindowSize() {
		this.logoMini = window.innerWidth < 959 ? true : false;
	}

	getRouterLink(){
		if(this.temAcesso){
			this.router.navigateByUrl('/');
		} else{
			this.router.navigateByUrl('/minha-conta/meus-pedidos')
		}
	}

	abrirNotificacoes(){
		this.router.navigateByUrl('/mural-avisos')
	}

	openDialogPesquisaDetalhada(): void {
		const dialogRef = this.dialog.open(PesquisaAvancadaComponent, {
			width: 'auto',
			height: 'auto',
			maxWidth: 'none',
			data: this.consultaDetalhada,
			disableClose: true
		});
		dialogRef.afterClosed().subscribe((consulta: any) => {
			if (consulta && consulta['filtrado']) {
				this.consultaDetalhada = new ConsultaDetalhada();
				this.qtdFiltros = consulta['qtdFiltros'];
				this.aplicarFiltros(consulta['consulta']);
			}else{
				this.qtdFiltros = consulta ? consulta['qtdFiltros'] : 0;
				this.consultaDetalhada = new ConsultaDetalhada();
			}
		});
	}

	aplicarFiltros(consulta: ConsultaDetalhada) {
		this.consultaDetalhada = consulta;
		this.searchbar.consultaDetalhada = consulta;

		const possuiTermoPesquisa = (localStorage.getItem('pesquisa') !== null && localStorage.getItem('pesquisa') !== '')
			|| this.searchbar.searchInput.nativeElement.value;

		if(possuiTermoPesquisa){
			this.searchbar.pesquisar();
		}
		// Sem termo de pesquisa: apenas guarda os filtros (acima) para serem
		// usados na proxima pesquisa, sem disparar busca nem mensagem de erro.
	}
}

